<script setup>
import { ref, watch } from 'vue'

import i18n from '@/i18n/i18n'

import { capitalizeFirstLetterOfWords } from '@/utilities/helpers'

const props = defineProps({
  environment: {
    type: String,
    required: true
  },
  branch: {
    type: String,
    required: true
  }
})

const initialEnvironmentInfo = {
  environment: props.environment,
  branch: props.branch
}

const { t } = i18n.global

const environmentDetails = ref({
  initialEnvironmentInfo
})

const branchNotificationText = branch => {
  if (props.environment === 'staging') {
    return t('store.public.environment_banner.test_environment')
  }
  return capitalizeFirstLetterOfWords(branch)
}

watch(
  () => [props.environment, props.branch],
  ([newEnvironment, newBranch]) => {
    initialEnvironmentInfo.environment = newEnvironment
    initialEnvironmentInfo.branch = newBranch

    environmentDetails.value = new Array(25).fill(initialEnvironmentInfo)
  }
)
</script>

<template>
  <div class="environment-banner fixed-top" :class="environment" role="alert">
    <div class="content d-flex align-items-center">
      <template v-for="(item, index) in environmentDetails" :key="index">
        <div class="rectangle" />
        <span class="font-12 font-semibold text-white px-2">{{ capitalizeFirstLetterOfWords(item.environment) }}</span>
        <div class="rectangle" />
        <span class="font-12 font-semibold text-white px-2">{{ branchNotificationText(item.branch) }}</span>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.environment-banner {
  height: 20px;
}

.dev {
  background-color: #c2d919;

  .content {
    padding: 10px 8px;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: clip;
    height: 20px;
  }

  .rectangle {
    width: 12px;
    height: 8px;
    background: #a8be00;
    flex-shrink: 0;
  }
}

.staging {
  background-color: #d7bff6;

  .content {
    padding: 10px 8px;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: clip;
    height: 20px;
  }

  .rectangle {
    width: 12px;
    height: 8px;
    background: #b881ff;
    flex-shrink: 0;
  }
}

.dynamic {
  background-color: #f8c9ee;

  .content {
    padding: 10px 8px;
    white-space: nowrap;
    width: 100%;
    overflow: hidden;
    text-overflow: clip;
    height: 20px;
  }

  .rectangle {
    width: 12px;
    height: 8px;
    background: #fb86d8;
    flex-shrink: 0;
  }
}
</style>
